import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Constant from '../../constants';


const MsgPopup = ({ showModal, handleContinue, msg, title }) => {
    return (
        <Modal show={showModal} onHide={handleContinue}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{msg}</Modal.Body>
            <Modal.Footer
                style={{ display: "inline-block", textAlign: "center" }}
            >
                <Button variant="primary"
                    className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas" onClick={handleContinue}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export const handleReposeError = async (data) => {
    try {
        const { resp, snackbarFun, setUser, navigate, otherProps } = data;

        //console.log("error.response.data--> "+ JSON.stringify( resp));

        let statusCode = 200;
        let errorCode = null;
        if (resp) {

            statusCode = resp?.status ?? (resp?.data?.status);
            errorCode = resp?.data?.errorCode;
            //url = resp?.config?.headers?.url ?? resp.config.url

        }

        console.log("errorCode--> " + errorCode);
        console.log("statusCode--> " + statusCode);

        //console.log("url--> "+ url);
        //console.log("resp?.data--> "+ resp?.data + "; JSON.stringify(resp?.data)--> "+ JSON.stringify(resp?.data));


        function timeout(delay) {
            return new Promise(res => setTimeout(res, delay));
        }


        const handleSpecialCharFoundFromServer = (data) => {
            snackbarFun(Constant.error.spclCharsDetected, 'error');
        }

        const handleOther400FromServer = (data) => {

            //console.log("data--> "+ JSON.stringify( data));
            if (data?.detail) {
                snackbarFun(data?.detail, 'error');
            }
        }

        const handleOther413FromServer = (data) => {
            //console.log("data--> "+ JSON.stringify( data));
            if (data?.detail) {
                snackbarFun(data?.detail, 'error');
            }
        }

        const handleFormValidationFromServer = (data) => {

            console.log(JSON.stringify(data));

            let errors = null;
            if (data?.errors && data?.errors?.length > 0) {
                errors = data?.errors.map(function (item, i) {

                    return item?.errorMessage ? item?.errorMessage + "; \n" : null;
                });
            }

            if (errors)
                snackbarFun(errors, 'error');
        }


        if (statusCode) {
            switch (statusCode) {
                case 500:
                    snackbarFun(Constant.error.serverDownError, 'error');
                    break;
                case 400:
                    if (Constant.VALIDATION_ERROR === errorCode) {
                        handleFormValidationFromServer(resp?.data);
                    }

                    if (Constant.XSS_DETECTED === errorCode) {
                        handleSpecialCharFoundFromServer(resp?.data);
                    }
                    else {
                        handleOther400FromServer(resp?.data);
                    }
                    break;
                case 401:
                    snackbarFun(Constant.error.unauthorized, 'error');
                    await timeout(2000);
                    setUser({ status: "" });
                    navigate("/login", { replace: true });
                    break;
                case 403:
                    if (JSON.stringify(resp.data).search(Constant.FIND_FOR_WAF_RESPONSE) > -1) {
                        console.log("WAF response...");
                        otherProps?.setIsWAFError(true);
                        //snackbarFun(Constant.error.webAppFireWallBlocked, 'error');
                        break;
                    }
                    else if (Constant.INVALID_CSRF_TOKEN == errorCode) {
                        snackbarFun(Constant.error.invalidCsrfToken, 'error');
                        break;
                    }
                    else if (Constant.INVALID_RECAPTCHA == errorCode) {
                        snackbarFun(Constant.error.invalidRecaptcha, 'error');
                        break;
                    }
                    else {
                        snackbarFun(Constant.error.body, 'error');
                        break;
                    }
                case 429:
                    if (Constant.TOO_MANY_REQUESTS == errorCode) {
                        snackbarFun(Constant.error.tooManyRequests, 'error');
                    }
                    break;
                case 413:
                    handleOther413FromServer(resp?.data);
                    break;

                default:
                    snackbarFun(Constant.error.body, 'error');
                    console.log("default:" + resp?.response?.status);
            }

        }
        else {
            snackbarFun(Constant.error.body, 'error');
        }




    } catch (e) {
        console.log("handleReposeError :: e -->" + e);
        console.log("handleReposeError :: e -->" + JSON.stringify(e));
    }

}

export default MsgPopup;
